import React, { lazy, Suspense } from 'react';

const LazyCartOrderPage = lazy(() => import('./CartOrderPage'));

const CartOrderPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyCartOrderPage {...props} />
  </Suspense>
);

export default CartOrderPage;
